{
  "limits": {
    "overlay": {
      "title": {
        "customColoursOnModels": "Couleurs personnalisées sur les modèles"
      },
      "content": {
        "text1": {
          "customColoursOnModels": "Vous n'avez actuellement pas accès à l'ajout de couleurs personnalisées à vos modèles 3D. Passez à la version supérieure pour travailler sur des plans en collaboration avec les autres membres de l'équipe.",
          "customSharedPlanExpiryDuration": "Effectuez une mise à niveau pour définir des durées d'expiration personnalisées pour les liens partagés."
        }
      }
    }
  }
}